import React from "react"
import PropTypes from "prop-types"
import { Link, useLocation, useParams } from "react-router-dom"
import { Row, Col, BreadcrumbItem } from "reactstrap"
import config from "../config"

const Breadcrumb = props => {

  return (
    <Row>
      <Col className="col-12">
        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
          <div className="page-title-right">
            <ol className="breadcrumb m-0">
                <BreadcrumbItem>
                    <Link to={`${config.appUrl}/`}>{props.title}</Link>
                  </BreadcrumbItem>
                  <BreadcrumbItem >
                    <Link to="#">{props.breadcrumbItem}</Link>
                  </BreadcrumbItem>
            </ol>
          </div>
        </div>
      </Col>
    </Row>
  )
}

Breadcrumb.propTypes = {
  breadcrumbItem: PropTypes.string,
  title: PropTypes.string,
}

export default Breadcrumb
